import { render } from "./AboutDetail.vue?vue&type=template&id=3bb718ed"
import script from "./AboutDetail.vue?vue&type=script&lang=js"
export * from "./AboutDetail.vue?vue&type=script&lang=js"

import "./AboutDetail.vue?vue&type=style&index=0&id=3bb718ed&lang=less"

import exportComponent from "/Users/longliu/Desktop/projects/povertyalleviation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__